import { render, staticRenderFns } from "./delivery_info.vue?vue&type=template&id=3b50a617&"
import script from "./delivery_info.vue?vue&type=script&lang=js&"
export * from "./delivery_info.vue?vue&type=script&lang=js&"
import style0 from "./delivery_info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports